import script from "./D3Plot.vue?vue&type=script&setup=true&lang=ts"
export * from "./D3Plot.vue?vue&type=script&setup=true&lang=ts"

import "./D3Plot.vue?vue&type=style&index=0&id=4a4b1fbc&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.24_vue@3.5.24_typescript@4.5.5__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a4b1fbc"]])

export default __exports__